import { useCallback } from 'react'
import { getUserAuthValues, isLoggedIn } from '@/src/utils/helper'

interface GtmEventHook {
    pushEventToDataLayer: (payload: Record<string, any>) => void
}

const useGtmEvent = (): GtmEventHook => {
    const pushEventToDataLayer = useCallback((payload: Record<string, any>) => {
        try {
            if (
                typeof window !== 'undefined' &&
                window.dataLayer &&
                Array.isArray(window.dataLayer)
            ) {
                // Add userId and isLoggedIn to all events
                const loggedIn = isLoggedIn()
                const { userId } = getUserAuthValues()

                const enrichedPayload = {
                    ...payload,
                    userId: loggedIn && userId ? userId : null,
                    isLoggedIn: loggedIn
                }

                window.dataLayer.push(enrichedPayload)

                // Log in development mode
                if (process.env.NODE_ENV === 'development') {
                    console.log('GTM Event:', enrichedPayload)
                }
            } else {
                console.warn('GTM: dataLayer not available')
            }
        } catch (error) {
            console.error('GTM: Error pushing to dataLayer:', error)
        }
    }, [])

    return {
        pushEventToDataLayer
    }
}

export default useGtmEvent
